import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=6a99143f&scoped=true"
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"
import style0 from "./table_form.vue?vue&type=style&index=0&id=6a99143f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a99143f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a99143f')) {
      api.createRecord('6a99143f', component.options)
    } else {
      api.reload('6a99143f', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=6a99143f&scoped=true", function () {
      api.rerender('6a99143f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy/form/promotion_product/table_form.vue"
export default component.exports